import debounce from 'lodash.debounce';
import kitman from './kitman';

export default function initProductListEndlessScroll() {
  const debugMode = false;
  const productListContainer = document.querySelector('#step2_products_list');
  if (!productListContainer) {
    return;
  }
  const productsPanel = productListContainer.parentElement;

  const handleScroll = () => {
    if (debugMode) {
      console.log('handleScroll()');
    }
    const scrollPosition = productListContainer.scrollHeight - productListContainer.clientHeight - productListContainer.scrollTop;
    if (scrollPosition <= 1200 && !productsPanel.classList.contains('loading') && !productListContainer.dataset.noProducts) {
      kitman.loadProducts(productListContainer.dataset.nextStep);
    }
  };
  const debouncedScroll = debounce(handleScroll, 100);

  if (productListContainer.dataset.nextStep) {
    productListContainer.addEventListener('scroll', debouncedScroll);
  }
}
